import React, { useEffect, useRef, useState, useContext } from "react";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import LanguageContext from "../../../context/language-context";
import { Link } from "react-router-dom";
export default function NewsItems(props) {
  const languageCtx = useContext(LanguageContext);

  const [truncatedContent, setTruncatedContent] = useState(null);
  const contentRef = useRef();
  const translations = {
    en: {
      read: "Read more",
    },
    fr: {
      read: "Lire la suite",
    },
    de: {
      read: "Mehr lesen",
    },
    ru: {
      read: "Читать далее",
    },
    es: {
      read: "Leer más",
    },
    it: {
      read: "Leggi tutto",
    },
  };
  useEffect(() => {
    if (props.content) {
      const updatedContent = props.content.map((paragraph, index) => {
        if (index === 0 && paragraph.children[0].text.length > 59) {
          return {
            ...paragraph,
            children: [
              {
                ...paragraph.children[0],
                text: paragraph.children[0].text.slice(0, 59),
              },
            ],
          };
        } else {
          return {
            ...paragraph,
            children: [], // Empty array to render no children
          };
        }
      });
      setTruncatedContent(updatedContent);
    }
  }, [props.content]);

  let productTitle = props.title;

  if (productTitle.includes(`-`)) {
    productTitle = productTitle.split(`-`).join(` `);
  }

  return (
    <li className="item">
      <Link to={`/news/${props.title}`}>
        <div className="uk-grid">
          <div className="wrapperImg">
            <div data-scroll="" data-scroll-speed="-.4" className="is-inview">
              <img
                src={`https://spagnoladmin.spagnolcompany.it${props.img}`}
                alt={props.title}
              />
            </div>
          </div>
          <div className="txt uk-width-1-2@m">
            <h5 className="t-xlarge t-bold">{productTitle}</h5>
            <div className="t-medium t-light" ref={contentRef}>
              {truncatedContent && (
                <BlocksRenderer
                  content={truncatedContent}
                  blocks={{
                    paragraph: ({ children }) => (
                      <p className="mt-4 text-base lg:text-xl">{children}</p>
                    ),
                    heading: ({ children, level }) => {
                      const Tag = `h${level}`;
                      return (
                        <Tag className="mt-4 font-bold text-base lg:text-2xl">
                          {children}
                        </Tag>
                      );
                    },
                    list: ({ children, format }) =>
                      format === "unordered" ? (
                        <ul className="list-disc list-inside ml-6 mt-4">
                          {children}
                        </ul>
                      ) : (
                        <ol className="list-decimal list-inside ml-6 mt-4">
                          {children}
                        </ol>
                      ),
                    quote: ({ children }) => (
                      <blockquote className="border-l-4 border-gray-300 pl-4 font-extrabold text-2xl text-black mt-4 w-[80%]">
                        {children}
                      </blockquote>
                    ),
                    link: ({ children, url }) => (
                      <Link to={url} className="text-footer underline">
                        {children}
                      </Link>
                    ),
                  }}
                />
              )}
            </div>

            <span className="read-more underline-hover-effect">
              <Link to={`/news/${props.title}`}>
                {" "}
                {translations[languageCtx.languageData].read}
              </Link>
            </span>
          </div>
        </div>
      </Link>
    </li>
  );
}
